module.exports = __webpack_public_path__ + "images/home/longueVue.d9a0b410.svg";